import type { FunctionComponent } from "react";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { useHomepageLogoLinkProps } from "scmp-app/components/header/hooks";

import { Container, StyledLogoLink, StyledScmpLogoFlag } from "./styles";

export type HeaderFeaturesLogoLinkProps = HeaderFeatureCommonProps;

export const HeaderFeaturesLogoLink: FunctionComponent<HeaderFeaturesLogoLinkProps> = ({
  ...props
}) => {
  const homepageLogoLinkProps = useHomepageLogoLinkProps();

  return (
    <Container {...getResponsiveProps(props)}>
      <StyledLogoLink {...homepageLogoLinkProps}>
        <StyledScmpLogoFlag />
      </StyledLogoLink>
    </Container>
  );
};

HeaderFeaturesLogoLink.displayName = "HeaderFeaturesLogoLink";
